import { Banner, BlockStack, Box, Button, Checkbox, Divider, Icon, InlineGrid, InlineStack, Loading, Modal, ProgressBar, Select, Spinner, Text, Tooltip } from '@shopify/polaris'
import { DockSideMajor, EditMajor, WandMinor } from '@shopify/polaris-icons';
import React, { useEffect, useState } from 'react';
import { useMediaQuery } from '../../../Utilities/useMediaQuery';
import Noimage from '../../../../../public/files/noImage.png';
import { DIProps, DIredux } from '../../../../../src/Core';
import pLimit from 'p-limit';
import { t } from 'i18next';


const options = [
    { label: t('EraseBG-Plus+'), value: t('option-2'), help_text: "" },
    { label: t('EraseBG-Pro'), value: 'option-4' },
    { label: t('EraseBG-Lite'), value: 'option-1', help_text: "" },
    { label: t('Remove-bg'), value: 'option-3' },
];

interface props extends DIProps {
    isSingleEdit: any,
    setBgModalOpen: (data: any) => void
    bgModalOpen: any
    selectedRows?: any
    setselectedRows: (setselectedImage: any) => void
    activityRefreshAction: () => void
}

const RemoveBgModalBulk = (props: props) => {



    const { isSingleEdit, setBgModalOpen, bgModalOpen, selectedRows, setselectedRows, activityRefreshAction } = props;
    const [removeBg, setRemoveBg] = useState(false);
    const [loader, setLoader] = useState<boolean>(false);
    const [showOriginalImage, setShowOriginalImage] = useState<boolean>(false);
    const isMobileView = useMediaQuery('(max-width: 576px)');
    const [allImages, setallImages] = useState<any>([])
    const [allSelectedImages, setallSelectedImages] = useState<any>([])
    const [loading, setloading] = useState<boolean>(false)
    const [selectedImageURL, setselectedImageURL] = useState<any>({})
    const [variantCount, setvariantCount] = useState(0)
    const [parentCount, setParentCount] = useState(selectedRows.length)
    const [serverValue, setserverValue] = useState("option-2")
    const [FlagForResetAllButton, setFlagForResetAllButton] = useState(true)
    const [someAlreadyConverted, setsomeAlreadyConverted] = useState(false)
    const [allConverted, setallConverted] = useState(false)
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        // Update the parent count based on the selected rows
        setParentCount(selectedRows.length);

        // Proceed only if the background modal is open
        if (bgModalOpen === true) {
            const payload = {
                source_product_ids: [...selectedRows]
            };

            // Make the API call to fetch images using the payload
            props.di.POST("connector/product/getSourceProductIdWiseImages", payload)
                .then(response => {
                    if (response.success) {
                        if (response.data.length > 0) {
                            const flatData: any[] = [];
                            // Iterate through each product in the API response
                            response.data.forEach((product: any) => {
                                // Check if the product has an images array
                                if (product.images && Array.isArray(product.images)) {
                                    product.images.forEach((img: any) => {
                                        // Update state with unique images that are not from the smartlister conversion
                                        setallSelectedImages((prevImages: string[]) => {
                                            if (
                                                !img.main_image.includes('smartlister-image-upload.s3') &&
                                                !prevImages.includes(img.main_image)
                                            ) {
                                                return [...prevImages, img.main_image];
                                            }
                                            return prevImages;
                                        });

                                        // Set a flag if any image belongs to smartlister conversion
                                        if (img.main_image.includes("smartlister-image-upload.s3")) {
                                            setsomeAlreadyConverted(true);
                                        }

                                        // Push a flat object for each image with the required structure
                                        if (
                                            img.main_image.includes('smartlister-image-upload.s3')

                                        ) {
                                            flatData.push({
                                                image: img.main_image,
                                                name: product.title,
                                                processing: false,
                                                source_product_ids: img.source_product_id, // should be an array of IDs
                                                container_id: product.container_id,
                                                selected: false
                                            });

                                        } else {
                                            // Push a flat object for each image with the required structure
                                            flatData.push({
                                                image: img.main_image,
                                                name: product.title,
                                                processing: false,
                                                source_product_ids: img.source_product_id, // should be an array of IDs
                                                container_id: product.container_id,
                                                selected: true
                                            });

                                        }
                                    });
                                }
                            });

                            // Update the variant count (if provided in the response)
                            setvariantCount(response.count);

                            // If no image is currently selected, set the first one from the flat data
                            if (Object.keys(selectedImageURL).length === 0) {
                                if (flatData[0] && flatData[0].image) {
                                    setselectedImageURL({
                                        image: flatData[0].image,
                                        container_id: flatData[0]?.container_id
                                    });
                                }
                            }

                            console.log(flatData, "xdcfvgbhn")

                            // Save the transformed flat data into state
                            setallImages(flatData);
                        } else {
                            props.error("No Data Found");
                        }
                    } else {
                        props.error(t(response.message));
                    }
                })
                .catch(error => {
                    // Handle any unexpected errors from the API call
                    props.error(t("An error occurred while fetching images"));
                });
        }
    }, [bgModalOpen, selectedRows]);







    const handleHold = () => {
        setShowOriginalImage(true);
    };

    const handleRelease = () => {
        setShowOriginalImage(false);
    };

    const renderBgRemove = () => {
        const filteredArray = allImages.filter((item: any) => ((item.image === selectedImageURL?.image) && (item.container_id == selectedImageURL?.container_id)));
        return (
            <div className={`custom-ai-main_edit--img ${loader ? 'custom-ai-active-loader' : ''}`} id="custom-ai-main_edit--img">

                <img src={selectedImageURL.image || Noimage} alt="Product Image" className={`custom-ai-originalImage ${showOriginalImage ? 'showImg' : ''}`} />
                <img src={filteredArray[0]?.updatedUrl ?? (selectedImageURL.image || Noimage)} alt="product_image" id='test-main-img' className={`${showOriginalImage ? 'hidimge' : ''}`} />
                <div className="custom-ai-main_img--footer">
                    <span className=""></span>
                    {!selectedImageURL?.image?.includes("smartlister-image-upload.s3") && <span className="custom-ai-compare-svg" onMouseDown={handleHold}
                        onMouseUp={handleRelease}
                        onTouchStart={handleHold}
                        onTouchEnd={handleRelease}>
                        <Tooltip content="Hold to compare" preferredPosition='below' persistOnClick>
                            <Icon source={DockSideMajor} />
                        </Tooltip>
                    </span>}
                </div>
                {
                    filteredArray[0]?.processing && <div className="custom_img--loader">
                        <Spinner />
                    </div>
                }
            </div>
        )
    }


    const handleCheckBox = (data: any) => {
        setallImages((prevItems: any) =>
            prevItems.map((item: any) => {
                if (item.container_id === data?.container_id && item?.image == data?.image) {
                    const newItem = { ...item, selected: !item.selected };
                    // delete newItem.updatedURL; // Removes the key if it exists
                    return newItem;
                }
                return item;
            })
        );

        // setallSelectedImages((prevImages: string[]) => {
        //     if (prevImages.includes(data?.image)) {
        //         // If it exists, remove it
        //         return prevImages.filter((img) => img !== data?.image);
        //     } else {
        //         // If it does not exist, add it
        //         return [...prevImages, data?.image];
        //     }
        // });
    }


    const apiUrls = [
        "smartlister/remoteadmin/removeBackground",               // API 1: Single image URL
        "smartlister/remoteadmin/bulkRemoveBackgroundPartOne",      // API 2: Single image URL in an array
        "smartlister/remoteadmin/bulkRemoveBackgroundPartTwo"       // API 3: Single image URL in an array
    ];

    // Limit of concurrent requests (6 total concurrent requests: 2 per API)
    const limit = pLimit(6); // Allow up to 6 concurrent requests in total

    // Helper function to introduce a delay
    const delay: any = (ms: number): Promise<void> =>
        new Promise(resolve => setTimeout(resolve, ms));

    // Function to process images using multiple APIs
    const processImagesConcurrently = async (
    ): Promise<void> => {

        const successfullyProcessed = new Set<string>(); // Track successful images
        const failedProcessed = new Set<string>(); // Track failed images

        // To process each image with the correct API and payload
        const processImage = async (image: any, apiUrl: string): Promise<void> => {
            const index = allImages.findIndex((img: any) => (img?.["container_id"] === image?.['container_id'] && img?.image === image?.image));

            // Mark the image as "processing" in the state
            setallImages((prev: any) =>
                prev.map(((img: any, i: number) =>
                    i === index ? { ...img, processing: true, updatedUrl: null } : img
                )
                ))

            try {
                // Prepare the payload based on the API
                const payload =
                    apiUrl === apiUrls[0]
                        ? { url: image.image, height: 100, width: 100, server: serverValue || "option-1" } // For API 1 (removeBackground)
                        : { url: [image.image], height: 100, width: 100, server: serverValue || "option-1" }; // For API 2 and 3 (bulk APIs)

                // Perform the API request
                const response: any = await props.di.POST(apiUrl, payload);

                if (response?.success) {
                    let updatedUrl: string | null = null;
                    if (response?.data?.[0]?.updatedURL) {
                        updatedUrl = response?.data?.[0]?.updatedURL || null; // Use the first item if it's an array
                    } else if (typeof response.updatedURL === "string") {
                        updatedUrl = response.updatedURL; // Use directly if it's a string
                    }
                    // const updatedUrl = response.updatedURLs?.[0] || null;
                    // Update the image with the result in the state
                    setallImages((prev: any) => {
                        return (
                            prev.map((img: any, i: number) => {

                                return (
                                    i === index
                                        ? { ...img, processing: false, updatedUrl: updatedUrl } // Update state with processed image
                                        : img

                                )
                            }
                            )
                        )
                    }
                    );

                    successfullyProcessed.add(image.image);
                } else {
                    throw new Error(`API failed for ${image.name}: ${JSON.stringify(response)}`);
                    failedProcessed.add(image.image); // Track failed processing
                }
            } catch (error) {
                console.error(`Error processing image ${image.name} on ${apiUrl}:`, error);

                // Reset the "processing" state in case of failure
                setallImages((prev: any) =>
                    prev.map((img: any, i: number) =>
                        i === index ? { ...img, processing: false, updatedUrl: null } : img
                    )
                );
                failedProcessed.add(image.image); // Track failed processing
            } finally {
                // Update progress
                const completed = successfullyProcessed.size + failedProcessed.size;
                const total = allImages.length;
                setProgress(Math.round((completed / total) * 100));
            }
        };

        // Handle processing all images concurrently with API limiting
        const processImagesInBatches = async () => {
            const batchSize = 3; // One image per API in each batch
            let TempAllImages = allImages.filter((data: any) => !data.image.includes("smartlister-image-upload.s3"))
            TempAllImages = allImages.filter((data: any) => data?.selected == true)
            const totalBatches = Math.ceil(TempAllImages.length / batchSize);

            // Set all images to loading (processing: true) at the start
            setallImages((prev: any) =>
                prev.map((img: any) => {
                    if (img.image.includes('smartlister-image-upload.s3') || !img?.selected) {
                        // Return the image unchanged if it includes the URL
                        return img;
                    }
                    // Otherwise, update the processing and updatedUrl fields
                    return {
                        ...img,
                        processing: true,
                        updatedUrl: null,
                    };
                })
            );

            for (let batchIndex = 0; batchIndex < totalBatches; batchIndex++) {
                let imageRequests: Promise<void>[] = [];
                const batchStart = batchIndex * batchSize;
                const currentBatch = TempAllImages.slice(batchStart, batchStart + batchSize);

                // Assign each image in the batch to an API and create requests
                currentBatch.forEach((image: any, index: number) => {
                    const apiUrl = apiUrls[index % apiUrls.length]; // Rotate through the APIs (1, 2, 3)

                    imageRequests.push(
                        limit(() =>
                            processImage(image, apiUrl) // Process the image via the selected API
                        )
                    );
                });

                try {
                    // Wait for the current batch to complete
                    await Promise.all(imageRequests);


                    // Delay before the next batch
                    if (batchIndex < totalBatches - 1) {
                        await delay(1000);
                    }
                } catch (error) {
                    console.error(`Error processing batch ${batchIndex + 1}:`, error);
                }
            }

        };

        // Start processing images in batches
        await processImagesInBatches();
        // Check if all images were processed successfully or not
        if (failedProcessed.size === 0) {

            setFlagForResetAllButton(false)
            setallConverted(true)
            props.success(t("Background successfully removed for the selected Images")) // Call success prop callback
        } else {
            console.error("Some images failed to process:", Array.from(failedProcessed));
            props.error(t("Image removal failed")); // Call failure callback with failed images
        }
        setloading(false)


    };


    const handleProcessImages = async () => {
        setloading(true)
        await processImagesConcurrently();
    };

    const saveImages = async () => {
        const chunkSize = 50; // Each chunk contains up to 50 source_product_ids
        const payloadChunks = []; // To hold chunks of payload
        setloading(true)


        // Flatten the input data
        const allPayloads = allImages.flatMap((element: any) => {
            if (element.updatedUrl && element?.selected) {
                return element.source_product_ids.map((source_product_id: any) => ({
                    main_image: element.updatedUrl,
                    target_marketplace: "amazon",
                    shop_id: props.redux?.current?.target?._id,
                    source_product_id,
                    source_shop_id: props.redux?.current?.source?._id,
                    container_id: element?.container_id,
                }));
            }
            return []; // Skip this element if no main_image
        });

        console.log(allPayloads, "dffcvghbjnmkfcgv")

        // Create chunks with chunkSize limit
        for (let i = 0; i < allPayloads.length; i += chunkSize) {
            payloadChunks.push(allPayloads.slice(i, i + chunkSize));
        }

        let allSuccess = true; // Flag to track overall success

        // // Process each chunk sequentially
        for (let chunkIndex = 0; chunkIndex < payloadChunks.length; chunkIndex++) {
            const payload = payloadChunks[chunkIndex]; // Current chunk of payload

            try {
                // Simulate API call
                console.log(`Saving Chunk ${chunkIndex + 1}:`, payload); // Debugging
                await callApi(payload);
                console.log(`Chunk ${chunkIndex + 1} saved successfully.`);
            } catch (error) {
                console.error(`Error in Chunk ${chunkIndex + 1}:`, error);
                allSuccess = false; // If any call fails, mark overall status as false
            }

            // Add delay between chunks to avoid overloading the API
            if (chunkIndex < payloadChunks.length - 1) {
                await new Promise((resolve) => setTimeout(resolve, 1000)); // Adjust delay if necessary
            }
        }

        setloading(false)

        // Show success or error messages
        if (allSuccess) {
            resetStates(true);
            props.success("All images have been saved successfully!");
        } else {
            props.error("Some images could not be saved. Please check the logs for details.");
        }
    };

    const callApi = async (payload: any) => {
        try {
            console.log("Making API call with payload:", payload);
            const response = await props.di.POST("connector/product/saveProduct", payload);

            if (response.success) {
                console.log("API call successful:", response);
            } else {
                console.error("API call failed with message:", response.message);
                props.error(t(response.message));
            }
        } catch (error) {
            console.error("Error during API call:", error);
            props.error(t("An error occurred while saving the product."));
        }
    };






    const resetImages = () => {
        const temp = allImages.map((data: any) => {
            const { updatedUrl, ...rest } = data; // Destructure and omit updatedUrl
            return rest;
        });
        setallImages(temp); // Update state with the new array
        setallConverted(false)
        props.success(t("All images have been reset successfully!"))
        setFlagForResetAllButton(true)
    };

    const resetStates = (flag: boolean = false) => {
        if (allConverted && flag) {
            activityRefreshAction()
        }

        setRemoveBg(false);
        setLoader(false);
        setShowOriginalImage(false);
        setallImages([]);
        setallSelectedImages([]);
        setloading(false);
        setselectedImageURL({});
        setvariantCount(0);
        setParentCount(selectedRows.length); // Recalculate based on `selectedRows`
        setserverValue("");
        setFlagForResetAllButton(true);
        setsomeAlreadyConverted(false);
        setallConverted(false);
        setBgModalOpen(false)
    };

    return (
        <Modal open={bgModalOpen}
            onClose={() => {
                if (loading && allConverted) {
                    props.error(("Please wait while the images are being saved"))
                } else if (loading && !allConverted) {
                    props.success(t("Please wait while the images are being loaded with removed background"))
                } else {
                    resetStates(false)

                }
            }
            }
            title="Remove Image Background"
            primaryAction={{
                content: allConverted ? "Save Images" : "Remove Background",
                disabled: !(allImages.filter((image: any) => image.selected == true).length > 0),
                onAction: () => allConverted ? saveImages() : handleProcessImages(),
                loading: loading
            }}
            secondaryActions={[{
                content: t("Reset all"),
                disabled: FlagForResetAllButton,
                onAction: () => resetImages()
            }]}
            {...!isSingleEdit && { size: "large" }
            }
        >
            <React.Fragment>
                {loading && progress > 0 && <ProgressBar size='small' progress={progress} tone="primary" />}
                <Box paddingInline={"500"} paddingBlock={"300"}>
                    <BlockStack gap={"200"}>
                        {someAlreadyConverted && <Banner tone='warning'>A few images with already removed background are also selected here. You may try unselecting them from the grid.</Banner>}
                        <Text as='p' variant='bodyMd'>Effortlessly remove image backgrounds in bulk, including product variant images.</Text>
                    </BlockStack>
                </Box>
                <Divider />
                <InlineGrid columns={isMobileView ? 1 : 2}>
                    <BlockStack>
                        {!isMobileView && <Box paddingInline={"300"} paddingBlock={"200"}>
                            <Select
                                label=""
                                labelHidden
                                value={serverValue}
                                onChange={(value) => setserverValue(value)}
                                options={options}
                                helpText={options.filter((option: any) => option.value == serverValue)[0]?.help_text && <Text as='p' variant='bodySm' tone='subdued'>{options.filter((option: any) => option.value == serverValue)[0]?.help_text}</Text>}
                            />
                        </Box>}
                        {removeBg && <div className='custom-ai-bg-remove__progress'>
                            <ProgressBar size='small' animated tone='success' progress={40} />
                        </div>}
                        <div className='custom-ai-primary-item-list'>
                            {
                                allImages.map((item: any, ind: number) => {
                                    // console.log(allImages?.filter((image: any) => image?.source_product_id == item?.source_product_id)[0].selected,"xtcvybuniofvgbhjn")
                                    return (
                                        <React.Fragment key={ind}>
                                            <div onClick={() => setselectedImageURL({
                                                image: item.image,
                                                container_id: item?.container_id
                                            })} className={((selectedImageURL?.image === item.image) && (selectedImageURL?.container_id == item?.container_id)) ? "custom-ai-list-item__selected" : "custom-ai-list-item"}>
                                                <Box paddingInline={"400"} paddingBlock={"150"}>
                                                    <InlineStack blockAlign='center' gap={"400"} wrap={false}>
                                                        {
                                                            item.image?.includes("smartlister-image-upload.s3") ? <Tooltip content="Background already removed for this image!">
                                                                <Checkbox label labelHidden checked={allImages?.filter((image: any) => (image?.container_id == item?.container_id && image?.image == item?.image))[0].selected} disabled={true} onChange={() => handleCheckBox(item)} />
                                                            </Tooltip> :
                                                                <Checkbox label labelHidden checked={allImages?.filter((image: any) => (image?.container_id == item?.container_id && image?.image == item?.image))[0].selected} disabled={false} onChange={() => handleCheckBox(item)} />

                                                        }
                                                        <div className='custom-item-list__bg-remove'>
                                                            <img src={item.image} />
                                                            {item?.processing && <div className='custom-item-list__bg-progress'>
                                                                <Spinner size='small' />
                                                            </div>}
                                                        </div>
                                                        <Text as='p' variant='bodyMd'>{item.name}</Text>
                                                    </InlineStack>
                                                </Box>
                                            </div>
                                            <Divider />
                                        </React.Fragment>
                                    )
                                })
                            }
                            <div className='custom-ai-total__bottomSticky'>
                                <Text as='p' variant='bodyXs' fontWeight='medium'>{`Editing ${allImages.filter((image: any) => image.selected == true).length} images of ${parentCount} products with ${variantCount - parentCount} variants`}</Text>
                            </div>
                        </div>
                    </BlockStack>
                    <div className='custom-vertical-separator'>
                        <Box paddingInline={"1200"} paddingBlock={"400"}>
                            <BlockStack gap={"150"} align='center'>
                                {isMobileView && <Select
                                    label=""
                                    labelHidden
                                    value={serverValue}
                                    onChange={(value) => setserverValue(value)}
                                    options={options}
                                    helpText={options.filter((option: any) => option.value == serverValue)[0]?.help_text && <Text as='p' variant='bodySm' tone='subdued'>{options.filter((option: any) => option.value == serverValue)[0]?.help_text}</Text>}
                                />}
                                <Text as="p" variant='headingMd'>Preview</Text>
                                {renderBgRemove()}
                            </BlockStack>
                        </Box>
                    </div>
                </InlineGrid>
            </React.Fragment>
        </Modal>
    )
}


type ImageItem = {
    name: string;
    image: string;
    processing?: boolean; // Tracks if the image is being processed
    updatedUrl?: string | null; // Holds the updated URL after processing,
    source_product_ids?: any
};


export default RemoveBgModalBulk;